/**
 * @description
 * Objeto dbindexflds
 */
import { Dbindices } from "./dbindices.model";
import { Xmlfields } from "./xmlfields.model";

export class Dbindexflds {
    public id:number = null;
    public dbindexId: Dbindices = new Dbindices();
    public sequence:number = 0;
    public xmlfieldId: Xmlfields = new Xmlfields();
  
    constructor() {}
  
}